import { Chip } from "@mui/material";

export const MuiChip = Chip;
